import React, { useCallback, useState } from 'react';
import Cropper from 'react-easy-crop';

interface ImageCropperProps {
  image: string;
  onCropComplete: (croppedDataUrl: string) => void;
  onCancel: () => void;
}

const createImage = (url: string): Promise<HTMLImageElement> => {
  return new Promise((resolve, reject) => {
    const image = new window.Image();
    image.addEventListener('load', () => resolve(image));
    image.addEventListener('error', error => reject(error));
    image.setAttribute('crossOrigin', 'anonymous');
    image.src = url;
  });
};

async function getCroppedImg(imageSrc: string, crop: any) {
  const image = await createImage(imageSrc);
  const canvas = document.createElement('canvas');
  const scaleX = image.naturalWidth / image.width;
  const scaleY = image.naturalHeight / image.height;
  canvas.width = crop.width;
  canvas.height = crop.height;
  const ctx = canvas.getContext('2d');
  if (!ctx) return '';
  ctx.drawImage(
    image,
    crop.x * scaleX,
    crop.y * scaleY,
    crop.width * scaleX,
    crop.height * scaleY,
    0,
    0,
    crop.width,
    crop.height
  );
  return canvas.toDataURL('image/jpeg');
}

const ImageCropper: React.FC<ImageCropperProps> = ({ image, onCropComplete, onCancel }) => {
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState<any>(null);

  const onCropCompleteCb = useCallback((_: any, croppedAreaPixels: any) => {
    setCroppedAreaPixels(croppedAreaPixels);
  }, []);

  const handleDone = async () => {
    if (croppedAreaPixels) {
      const croppedImg = await getCroppedImg(image, croppedAreaPixels);
      onCropComplete(croppedImg);
    }
  };

  return (
    <div className="media-library-modal">
      <div className="media-library-content" style={{ maxWidth: 500 }}>
        <div className="media-library-header">
          <span>Crop Image</span>
          <button className="media-library-close" onClick={onCancel}>×</button>
        </div>
        <div style={{ position: 'relative', width: '100%', height: 300, background: '#222' }}>
          <Cropper
            image={image}
            crop={crop}
            zoom={zoom}
            aspect={4 / 3}
            onCropChange={setCrop}
            onZoomChange={setZoom}
            onCropComplete={onCropCompleteCb}
          />
        </div>
        <div className="media-library-actions">
          <button className="media-library-btn media-library-btn--cancel" onClick={onCancel}>Cancel</button>
          <button className="media-library-btn media-library-btn--primary" onClick={handleDone}>Crop & Use</button>
        </div>
      </div>
    </div>
  );
};

export default ImageCropper;

